import { useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import CnfModal from "../../../../../../Components/BookingComponents/AllModals/CnfModal/CnfModal";
import LoadingCompleteModal from "../../../../../../Components/BookingComponents/AllModals/CurrentTaskModal/LoadingCompletedModal/LoadingCompleteModal";
import UnloadingComplete from "../../../../../../Components/BookingComponents/AllModals/CurrentTaskModal/UnloadingCompleteModal/UnloadingCompleteModal";
import VehicleReachedAtUnloadingPointModal from "../../../../../../Components/BookingComponents/AllModals/CurrentTaskModal/VehicleReachedAtUnloadingPointModal/VehicleReachedAtUnloadingPointModal";
import ViewClaimModal from "../../../../../../Components/BookingComponents/AllModals/CurrentTaskModal/ViewClaimModal/ViewClaimModal";
import RaiseClaimModal from "../../../../../../Components/BookingComponents/AllModals/RaiseClaimModal/RaiseClaimModal";
import CurrentTaskTable from "../../../../../../Components/BookingComponents/CurrentTaskTable/CurrentTaskTable";
// import Reactportal from "../../../../../../Components/SpComponents/Reactportal/Reactportal";
import { useDispatch } from "react-redux";
import { emtSocket } from "../../../../../../../CommonFunction/SocketClient";
import ProcessAdvanceModal from "../../../../../../Components/BookingComponents/AllModals/CurrentTaskModal/ProcessAdvanceModal/ProcessAdvanceModal";
import Button from "../../../../../../Components/Button/Button";
import { ErrorToast, SuccessToast } from "../../../../../../Components/ToastComponent/RectHotToast";
import "./CurrentTask.scss";
import Reactportal from "../../../../../../Components/Reactportal/Reactportal";

const EDIT_COMMITTED_VEHICLES_DATA = gql`
  mutation EditTripBookings($UserId: ID, $id: ID!, $userInput: TripBookingsInput) {
    editTripBookings(UserId: $UserId, id: $id, userInput: $userInput) {
      createdAt
    }
  }
`;

const EDIT_TRIP_BOOKING = gql`
  mutation EditTripBookings_Without_VerifyUserWithBalance($id: ID!, $userInput: TripBookingsInput!) {
    editTripBookings_Without_VerifyUserWithBalance(id: $id, userInput: $userInput) {
      id
      LoadId
      Vehicle_Number {
        _id
        Vehicle_No
      }
      TripBooking_Confirmed
      Advance_Processed
      Clear_Delivery_Confirmation
      Loading_Completed
      Unloading_Completed
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reached_At_Loading_Point
    }
  }
`;

function CurrentTask({
  SpId,
  LpId,
  loadId,
  CommittedVehicleId,
  CommittedVehicleUniqueId,
  VehicleNo,
  Current_Stage,
  Sp_Claim_Raised,
  Lp_Claim_Raised,
  Sp_Claim_Cleared,
  Lp_Claim_Cleared,
  freightAmount,
  paymentType,
  data,
}) {
 
  const [
    editCommittedVehiclesDataWithoutVerifyBalance,
    { loading: editCommittedVehiclesDataWithoutVerifyBalanceLoading },
  ] = useMutation(EDIT_TRIP_BOOKING, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [lpRaiseClaimModal, setLpRaiseClaimModal] = useState(false);
  const [processAdvanceModal, setProcessAdvanceModal] = useState(false);
  const [cnfModal, setCnfModal] = useState(false);
  const [loadingCompletedModal, setLoadingCompletedModal] = useState(false);
  const [noClaimCnfModal, setNoClaimCnfModal] = useState(false);
  const [spviewClaimModal, setSPViewClaimModal] = useState(false);
  const [lpviewClaimModal, setLPViewClaimModal] = useState(false);
  const [spRaiseClaimModal, setSpRaiseClaimModal] = useState(false);
  const [advance, setAdvance] = useState(0);
  const dispatch = useDispatch();
  const [vehicleReahedAtUnloadingPointModal, setVehicleReahedAtUnloadingPoint] = useState(false);
  const [unloadingComplete, setUnloadComplete] = useState(false);
  const [
    editCommittedVehiclesData,
    { loading: editCommittedVehiclesDataLoading },
  ] = useMutation(EDIT_COMMITTED_VEHICLES_DATA, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  function calculate() {
    if (paymentType === "To Pay") {
      setAdvance(0);
    } else if (paymentType === "Advance 100%") {
      setAdvance(freightAmount);
    } else {
      setAdvance((90 / 100) * freightAmount);
    }
  }

  useEffect(() => {
    calculate();
  }, [paymentType, freightAmount]);

  async function handleCommittedVehiclesChangeWithoutVerifyBalance({ updateObj, msg }) {
    await editCommittedVehiclesDataWithoutVerifyBalance({
      variables: {
        UserId: SpId,
        id: CommittedVehicleId,
        userInput: updateObj,
      },
    })
      .then((res) => {
        // emtSocket.emit("Update_CurrentTask", LpId, CommittedVehicleId);
        setCnfModal(false);
        setVehicleReahedAtUnloadingPoint(false);
        SuccessToast(msg);
        dispatch({ type: "Refetch", payload: true });
      })
      .catch((err) => ErrorToast(err.message));
  }

  function handleCommittedVehiclesChange({ updateObj, msg }) {
    if (msg === "Advance Processed") {
      editCommittedVehiclesData({
        variables: {
          id: CommittedVehicleId,
          userInput: updateObj,
          UserId: LpId,
        },
      })
        .then((res) => {
          SuccessToast("Advance Process completed");
          dispatch({ type: "Refetch", payload: true });
          setProcessAdvanceModal(false);
        })
        .catch((err) => ErrorToast(err.message));
    } else {
      editCommittedVehiclesData({
        variables: {
          id: CommittedVehicleId,
          userInput: updateObj,
        },
      })
        .then((res) => console.log(res))
        .catch((err) => console.log(err));
    }
  }

  return (
    <div className="currentTaskDiv">
      <p className="currentTaskHeader">Current Task</p>

      {Current_Stage === "Booking Confirmed" ? (
        <>
          <p className="taskMessage">Please confirm once the vehicle reaches at loading point</p>
          <Button text="Reached at Loading Point" className={"acceptBtn"} action={() => setCnfModal(true)} />

          <Reactportal
            open={cnfModal}
            modalHeading="Confirmation"
            onClose={() => setCnfModal(false)}
            modalClassName={"cnfModal"}
            contentClassName={"cnfModal-content"}
          >
            <CnfModal
              editCommittedVehiclesData={() => {
                handleCommittedVehiclesChangeWithoutVerifyBalance({
                  updateObj: {
                    Vehicle_Reached_At_Loading_Point: true,
                    Current_Stage: "Vehicle Reached At Loading Point",
                    Vehicle_Reached_At_Loading_Point_Time: new Date(),
                  },
                  msg: "Vehicle Reached At Loading Point",
                });
              }}
              cnfMessage={"Is Vehicle Reached At Loading Point ?"}
              onClose={() => setCnfModal(false)}
              loading={editCommittedVehiclesDataWithoutVerifyBalanceLoading}
            />
          </Reactportal>
        </>
      ) : (
        ""
      )}
      {Current_Stage === "Vehicle Reached At Loading Point" ? (
        <>
          <p className="taskMessage">Please confirm once the loading has been completed</p>
          <Button text="Loading Complete" className={"acceptBtn"} action={() => setLoadingCompletedModal(true)} />
          {/* <div>
          LP:{data.LP_Business_Name

}
          </div> */}
          <Reactportal
            open={loadingCompletedModal}
            modalHeading="Confirmation"
            onClose={() => setLoadingCompletedModal(false)}
            modalClassName={"cnfModal"}
            contentClassName={"cnfModal-content"}
          >
            <LoadingCompleteModal
              SpId={SpId}
              paymentType={paymentType}
              LpId={LpId}
              loadId={loadId}
              CommittedVehicleId={CommittedVehicleId}
              onClose={() => setLoadingCompletedModal(false)}
            />
          </Reactportal>
        </>
      ) : (
        ""
      )}
      {Current_Stage === "Loading Completed" ? (
        <>
          <p className="taskMessage">Please process the advance</p>
          <Button text="Process Advance" className={"acceptBtn"} action={() => setProcessAdvanceModal(true)} />
          <Reactportal
            open={processAdvanceModal}
            modalHeading="Confirmation"
            onClose={() => setProcessAdvanceModal(false)}
            modalClassName={"cnfModal"}
            contentClassName={"cnfModal-content"}
          >
            <ProcessAdvanceModal
              editCommittedVehiclesData={() => {
                handleCommittedVehiclesChange({
                  updateObj: {
                    Advance_Processed: true,
                    Current_Stage: "Advance Processed",
                    Advance_Processed_Time: new Date(),
                  },
                  msg: "Advance Processed",
                });
              }}
              LpId={LpId}
              onClose={() => setProcessAdvanceModal(false)}
              advance={advance}
              paymentType={paymentType}
              loading={editCommittedVehiclesDataLoading}
            />
          </Reactportal>
        </>
      ) : (
        ""
      )}
      {Current_Stage === "Advance Processed" ? (
        <>
          <p className="taskMessage">Please confirm once the vehicle reaches at unloading point</p>
          <Button
            text="Reached at Unloading Point"
            className={"acceptBtn"}
            action={() => setVehicleReahedAtUnloadingPoint(true)}
          />
          <Reactportal
            open={vehicleReahedAtUnloadingPointModal}
            modalHeading="Confirmation"
            onClose={() => setVehicleReahedAtUnloadingPoint(false)}
            modalClassName={"cnfModal"}
            contentClassName={"cnfModal-content"}
          >
            <VehicleReachedAtUnloadingPointModal
              editCommittedVehiclesData={(initialValues) => {
                handleCommittedVehiclesChangeWithoutVerifyBalance({
                  updateObj: {
                    ...initialValues,
                    Vehicle_Reach_At_Unloading_Point: true,
                    Current_Stage: "Vehicle Reach At Unloading Point",
                    Vehicle_Reach_At_Unloading_Point_Time: new Date(),
                  },
                  msg: "Vehicle Reach At Unloading Point",
                });
              }}
              SpId={SpId}
              onClose={() => setVehicleReahedAtUnloadingPoint(false)}
              loading={editCommittedVehiclesDataWithoutVerifyBalanceLoading}
            />
          </Reactportal>
        </>
      ) : (
        ""
      )}
      {Current_Stage === "Vehicle Reach At Unloading Point" ? (
        <>
          <p className="taskMessage">Please confirm once the vehicle has been unloaded</p>
          <Button text="Unloading Complete" className={"acceptBtn"} action={() => setUnloadComplete(true)} />
          <Reactportal
            open={unloadingComplete}
            modalHeading="Confirmation"
            onClose={() => setUnloadComplete(false)}
            modalClassName={"cnfModal"}
            contentClassName={"cnfModal-content"}
          >
            <UnloadingComplete
              LpId={LpId}
              SpId={SpId}
              loadId={loadId}
              CommittedVehicleId={CommittedVehicleId}
              onClose={() => setUnloadComplete(false)}
            />
          </Reactportal>
        </>
      ) : (
        ""
      )}
      {Current_Stage === "Unloading Completed" ? (
        <>
          <div className="currentTaskTableDiv">
            <CurrentTaskTable SpId={SpId} CommittedVehicleId={CommittedVehicleId} />
          </div>
          <div className="claimDiv">
            <div className="actionBtnDiv">
              {Sp_Claim_Raised && !Sp_Claim_Cleared ? (
                <div className="spClaimViewBtn">
                  <Button
                    text="View Claim"
                    name="modalbutton"
                    className={"acceptBtn"}
                    action={() => setLPViewClaimModal(true)}
                  />
                  <Reactportal
                    open={lpviewClaimModal}
                    modalClassName="cnfModal"
                    contentClassName="cnfModal-content"
                    modalHeading="Claim Details"
                    onClose={() => setLPViewClaimModal(false)}
                  >
                    <ViewClaimModal
                      SpId={SpId}
                      LpId={LpId}
                      UserType={"LP"}
                      loadId={loadId}
                      CommittedVehicleId={CommittedVehicleId}
                      CommittedVehicleUniqueId={CommittedVehicleUniqueId}
                      VehicleNo={VehicleNo}
                      LpClaim={true}
                      onClose={() => setLPViewClaimModal(false)}
                      Sp_Claim_Cleared={Sp_Claim_Cleared}
                      Lp_Claim_Cleared={Lp_Claim_Cleared}
                    />
                  </Reactportal>
                </div>
              ) : (
                ""
              )}

              {!Lp_Claim_Raised && !Lp_Claim_Cleared ? (
                <div className="lpClaimBtnDiv">
                  <Button
                    text="Raise A Claim"
                    name="modalbutton"
                    className={"acceptBtn"}
                    action={() => setLpRaiseClaimModal(true)}
                  />

                  <Reactportal
                    open={lpRaiseClaimModal}
                    modalClassName="cnfModal"
                    contentClassName="cnfModal-content"
                    modalHeading="Raise Claim"
                    onClose={() => setLpRaiseClaimModal(false)}
                  >
                    <RaiseClaimModal
                      SpId={SpId}
                      loadId={loadId}
                      LpRaise={true}
                      CommittedVehicleId={CommittedVehicleId}
                      onClose={() => setLpRaiseClaimModal(false)}
                    />
                  </Reactportal>

                  <Button
                    text="No Claim"
                    name="modalbutton"
                    className={"rejectBtn"}
                    action={() => setNoClaimCnfModal(true)}
                  />
                  <Reactportal
                    open={noClaimCnfModal}
                    modalHeading={"Confirmation"}
                    onClose={() => setNoClaimCnfModal(false)}
                    modalClassName={"cnfModal"}
                    contentClassName={"cnfModal-content"}
                  >
                    <CnfModal
                      cnfMessage={
                        "Hereafter you cannot raise a claim, Are you sure that you don't want to raise a claim ?"
                      }
                      editCommittedVehiclesData={() => {
                        let obj;

                        if (Sp_Claim_Cleared === true) {
                          obj = {
                            Lp_Claim_Cleared: true,
                            // Lp_Claim_Raised: false,
                            Clear_Delivery_Confirmation: true,
                            Current_Stage: "Clear Delivery Confirmation",
                            Clear_Delivery_Confirmation_Time: new Date(),
                          };
                        } else {
                          obj = {
                            Lp_Claim_Cleared: true,
                            // Lp_Claim_Raised: false,
                          };
                        }
                        handleCommittedVehiclesChangeWithoutVerifyBalance({
                          updateObj: obj,
                          msg: "No Claim Raised",
                        });
                        setNoClaimCnfModal(false);
                      }}
                      onClose={() => setNoClaimCnfModal(false)}
                      loading={editCommittedVehiclesDataWithoutVerifyBalanceLoading}
                    />
                  </Reactportal>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="actionBtnDiv">
              {Lp_Claim_Raised && !Lp_Claim_Cleared && (
                <div className="spClaimViewBtn">
                  <Button
                    text="View Claim"
                    name="modalbutton"
                    className={"acceptBtn"}
                    action={() => setSPViewClaimModal(true)}
                  />
                  <Reactportal
                    open={spviewClaimModal}
                    modalClassName="cnfModal"
                    contentClassName="cnfModal-content"
                    modalHeading="Claim Details"
                    onClose={() => setSPViewClaimModal(false)}
                  >
                    <ViewClaimModal
                      LpId={LpId}
                      SpId={SpId}
                      UserType={"SP"}
                      loadId={loadId}
                      CommittedVehicleId={CommittedVehicleId}
                      CommittedVehicleUniqueId={CommittedVehicleUniqueId}
                      VehicleNo={VehicleNo}
                      SpClaim={true}
                      onClose={() => setSPViewClaimModal(false)}
                      Sp_Claim_Cleared={Sp_Claim_Cleared}
                      Lp_Claim_Cleared={Lp_Claim_Cleared}
                    />
                  </Reactportal>
                </div>
              )}

              {!Sp_Claim_Raised && !Sp_Claim_Cleared ? (
                <div className="lpClaimBtnDiv">
                  <Button
                    text="Raise A Claim"
                    name="modalbutton"
                    className={"acceptBtn"}
                    action={() => setSpRaiseClaimModal(true)}
                  />
                  <Reactportal
                    open={spRaiseClaimModal}
                    modalClassName="cnfModal"
                    contentClassName="cnfModal-content"
                    modalHeading="Raise Claim"
                    onClose={() => setSpRaiseClaimModal(false)}
                  >
                    <RaiseClaimModal
                      LpId={LpId}
                      loadId={loadId}
                      SpRaise={true}
                      CommittedVehicleId={CommittedVehicleId}
                      onClose={() => setSpRaiseClaimModal(false)}
                    />
                  </Reactportal>

                  <Button
                    text="No Claim"
                    name="modalbutton"
                    className={"rejectBtn"}
                    action={() => setNoClaimCnfModal(true)}
                  />
                  <Reactportal
                    open={noClaimCnfModal}
                    modalHeading={"Confirmation"}
                    onClose={() => setNoClaimCnfModal(false)}
                    modalClassName={"cnfModal"}
                    contentClassName={"cnfModal-content"}
                  >
                    <CnfModal
                      cnfMessage={
                        "Hereafter you cannot raise a claim, Are you sure that you don't want to raise a claim ?"
                      }
                      editCommittedVehiclesData={() => {
                        let obj;

                        if (Lp_Claim_Cleared === true) {
                          obj = {
                            Sp_Claim_Cleared: true,
                            // Sp_Claim_Raised: false,
                            Clear_Delivery_Confirmation: true,
                            Current_Stage: "Clear Delivery Confirmation",
                            Clear_Delivery_Confirmation_Time: new Date(),
                          };
                        } else {
                          obj = {
                            Sp_Claim_Cleared: true,
                            // Sp_Claim_Raised: false,
                          };
                        }
                        handleCommittedVehiclesChangeWithoutVerifyBalance({
                          updateObj: obj,
                          msg: "No Claim Raised by you",
                        });
                      }}
                      onClose={() => setNoClaimCnfModal(false)}
                      loading={editCommittedVehiclesDataWithoutVerifyBalanceLoading}
                    />
                  </Reactportal>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      {Current_Stage === "Clear Delivery Confirmation" ? (
        <>
          <p className="taskMessage">Awaiting for the physical POD (Proof of Delivery) collected form SP.</p>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

export default CurrentTask;
